// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"528":"reports","660":"bookOfBetting","962":"home"}[chunkId] || chunkId) + "." + {"79":"9b52f2a7","320":"2860377d","528":"6edcd5b8","660":"e01adbe7","962":"484708de"}[chunkId] + ".css";
};